<template>
  <base-dialog v-model="value" title="Certificate" :maxWidth="1754" @close="close">
    <template #content>
      <div class="cert-container">
        <div id="divID" :style="divBgStyle">
          <div id="userName">
            <h1>{{ user.friendlyName }}</h1>
          </div>

          <h1 class="ma-0 pa-0" id="courseTitle">{{ course.title }}</h1>

          <h2 id="passed">
            {{ formatDateFull(course.createdOn) }}
          </h2>

          <div id="instructor">
            <div v-for="(instructor, i) in course.instructors" :key="i">
              <h2 class="instructor-font d-block">{{ instructor.name }}</h2>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #actions>
      <v-spacer></v-spacer>

      <v-btn color="grey darken-2" @click="close">Cancel</v-btn>

      <v-btn color="primary" class="ml-4" :loading="loading" @click="convertHTMLtoPDF"> Download Certificate </v-btn>
    </template>
  </base-dialog>
</template>

<script>
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import BaseDialog from "@base/BaseDialog.vue";

// ✔ Import the certificate background image
import certBg from "@/components/training/cert-acrisure-safety.png";
import Helpers from "@/mixins/helpers";

export default {
  name: "Certificate",

  props: ["value", "courseDetails", "registeredUser"],

  mixins: [Helpers],

  components: { BaseDialog },

  data() {
    return {
      valid: true,
      course: {},
      user: {},
      loading: false,

      // ✔ Vue-injected background image style
      divBgStyle: {
        backgroundImage: `url(${certBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        color: "black",
        height: "1240px",
        width: "1754px",
      },
    };
  },

  watch: {
    value: {
      handler() {
        this.course = { ...this.courseDetails };
        this.user = { ...this.registeredUser };
      },
      deep: true,
    },
  },

  methods: {
    convertHTMLtoPDF() {
      const div = document.querySelector("#divID");

      html2canvas(div).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg");

        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "in",
          format: "letter",
        });

        const props = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (props.height * pdfWidth) / props.width;

        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("Certificate.pdf");
      });
    },

    close() {
      this.loading = false;
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

<style>
.cert-container {
  position: relative;
  width: 1754px;
  height: 1240px;
}

#userName {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 24px;
  transform: translate(-50%, -50%);
}

#courseTitle {
  font-size: 40px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 62%;
}

#passed {
  position: absolute;
  top: 78%;
  left: 33%;
  font-size: 32px;
  transform: translate(-50%, -50%);
}

#instructor {
  position: absolute;
  top: 78%;
  left: 66%;
  transform: translate(-50%, -50%);
}

.instructor-font {
  font-size: 32px;
}
</style>
